import { useQuery } from "@tanstack/react-query";
import { DispatchApi } from "../../api/services";
import { PageHeader, SimBadge, Spinner, StatusBadge } from "../../components/common";
import { DataTable } from "../../components/DataTable";
import { dateTime, peso } from "../../lib/format";

export default function DispatchHistory() {
  const { data, isLoading } = useQuery({ queryKey: ["dispatch", "history"], queryFn: DispatchApi.history });
  if (isLoading) return <Spinner />;
  return (
    <div>
      <PageHeader title="Dispatch history" subtitle="Completed and cancelled requests (latest 200)." />
      <DataTable testId="dispatch-history-table" rows={data || []} columns={[
        { key: "code", label: "Ref", render: (b) => <span className="font-mono">{b.code}</span> },
        { key: "type", label: "Type", render: (b) => <span className="capitalize">{b.type}</span> },
        { key: "patient", label: "Patient", render: (b) => b.patient?.name },
        { key: "resp", label: "Responder", render: (b) => b.responder ? <span className="flex items-center gap-1">{b.responder.name}<SimBadge show={b.responder.is_simulated} /></span> : "—" },
        { key: "created", label: "Requested", render: (b) => dateTime(b.created_at) },
        { key: "closed", label: "Closed", render: (b) => dateTime(b.completed_at || b.cancelled_at) },
        { key: "fare", label: "Fare", render: (b) => `${peso(b.fare_estimate)} · ${b.payment_status}` },
        { key: "status", label: "Status", render: (b) => <StatusBadge status={b.status} /> },
      ]} />
    </div>
  );
}
